import { all } from "redux-saga/effects";
import { tienDoNhapDiemLopHanhChinhSaga } from "./tienDoNhapDiemLopHanhChinhSaga";
import { tienDoNhapDiemLopTinChiSaga } from "./tienDoNhapDiemLopTinChiSaga";

export default function* tongHopSagaWrapper() {
  yield all([
    tienDoNhapDiemLopHanhChinhSaga(),
    tienDoNhapDiemLopTinChiSaga()
  ]);
}